export const colors = {
    LandingPage_Front : '#F1F2F1',
    LandingPage_Background: '#E9E9E1',
    LandingPage_Description: '#373737',
    Button_Primary: '#EB1B22',
    Button_Secondary: '#EB1B22', 
    Header_Background: "#FFFFFF",
    Header_Content: '#000000',
    AppMenu_Header: '#090909',
    ResponsiveDrawer_Header: '#090909',
}